import { DropdownOptionType } from '@Components/Dropdown/Type';
import { styled } from '@mui/system';
import moment from 'moment';

export const searchFilterList = [
  { label: 'Carrier Invoice no.', value: 'carrierInvoiceNumber' },
  { label: 'Ref Invoice no.', value: 'refInvoiceNumber' },
  { label: 'Invoice No.', value: 'invoiceNumber' },
];

export const TableActionContainer = styled('div')(({ theme }) => ({
  margin: '2rem 0',
  display: 'grid',
  gridTemplateColumns: '380px 1fr fit-content(150px) fit-content(150px) fit-content(150px) fit-content(150px) 150px',
  columnGap: '15px',
  paddingTop: '10px',
  overflowX: 'auto', // ✅ allow scroll
  scrollbarWidth: 'none', // ✅ Firefox
  msOverflowStyle: 'none', // ✅ IE/Edge
  '&::-webkit-scrollbar': {
    display: 'none', // ✅ Chrome, Safari, Opera
  },

  [theme.breakpoints.down('xl')]: {
    columnGap: '8px',
    gridTemplateColumns: '380px 1fr fit-content(150px) fit-content(150px) fit-content(150px) fit-content(150px) 120px',
  },

  [theme.breakpoints.down('lg')]: {
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    gap: '1rem',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    div: {
      flex: '0 0 auto',
    },
  },
}));

export interface FilterObj {
  system?: string[];
  access?: string[];
  status?: string[];
  currentPage?: number | any;
  perPage?: number | any;
  searchKey?: string;
  searchValue?: string;
}

export const initialDateRange = {
  startDate: moment().subtract(1, 'months').startOf('day').toDate(),
  endDate: moment().endOf('day').toDate(),
};

export const StatusList = [
  { display: 'Paid', value: 'paid' },
  { display: 'Unpaid', value: 'unpaid' },
  { display: 'Void', value: 'void' },
];

// types/vendor.ts
export interface Vendor {
  id: string;
  name: string;
  totalOutstandingBalance: number;
  unpaidInvoices: number;
  paidInvoices: number;
  cnBalance: number;
}

export interface Transaction {
  id: string;
  invoiceNumber: string;
  mode: string;
  type: 'debit' | 'credit';
  amount: string;
  status: string;
  carrierId: string;
  description: string;
  createdAt: string;
  currency: string;
}

export interface VendorDetails extends Vendor {
  transactions: Transaction[];
}

export interface Carrier {
  _id: string;
  name: string;
  totalOutstandingBalance?: number;
  paidInvoicesCount?: number;
  unpaidInvoicesCount?: number;
  cnBalance?: number;
}
export interface BalanceInfo {
  totalInvoicedAmount: number;
  totalInvoicedPaidAmount: number;
}

export const IconStyle = { width: '33px', height: '33px' };
export interface MappedVendor {
  id: string;
  name: string;
  totalOutstandingBalance: number;
  paidInvoices: number;
  unpaidInvoices: number;
  cnBalance: number;
}

export const CreditWalletTableActionContainer = styled('div')(({ theme }) => ({
  padding: '32px 0',
  display: 'grid',
  gridTemplateColumns: '400px 1fr 1fr 1fr 1fr 140px',
  columnGap: '15px',
  [theme.breakpoints.down('xl')]: {
    padding: '32px 0px',
    columnGap: 10,
    gridTemplateColumns: '380px 0.5fr 1.5fr 1fr 1fr 1fr',
  },
  [theme.breakpoints.down('lg')]: {
    padding: '32px 0px',
    gap: 15,
    gridTemplateColumns: '340px 1fr 1.5fr',
    gridTemplateRows: 'repeat(2,1fr)',
    '.whiteSpace': {
      display: 'none',
    },
  },
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem',
    div: {
      width: 'auto',
    },
  },
}));

export type TransactionModes = 'cash' | 'creditnote';

export const PaymentModeList: { [key in TransactionModes]: DropdownOptionType } = {
  cash: {
    value: 'cash',
    display: 'Cash',
  },

  creditnote: {
    value: 'creditnote',
    display: 'Creditnote',
  },
};

export type TransactionType = 'credit' | 'debit';

export const TypeList: { [key in TransactionType]: DropdownOptionType } = {
  credit: {
    value: 'credit',
    display: 'Credit',
  },

  debit: {
    value: 'debit',
    display: 'Debit',
  },
};

export const CreditWalletSearchFilterList = [{ label: 'Invoice No.', value: 'invoiceNumber' }];
